document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-header]');
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-menu]');
  const modal = document.querySelector('[data-quote-modal]');
  const modelInput = modal?.querySelector('[data-quote-model]');

  const setHeaderState = () => header?.classList.toggle('is-scrolled', window.scrollY > 12);
  setHeaderState();
  window.addEventListener('scroll', setHeaderState, { passive: true });

  menuButton?.addEventListener('click', () => {
    const open = menu?.classList.toggle('is-open');
    menuButton.setAttribute('aria-expanded', String(Boolean(open)));
  });

  const openModal = (model) => {
    if (!modal) return;
    if (modelInput) modelInput.value = model || 'Spa consultation';
    modal.hidden = false;
    document.body.classList.add('jw-lock');
    window.setTimeout(() => modal.querySelector('input')?.focus(), 50);
  };
  const closeModal = () => {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('jw-lock');
  };
  document.querySelectorAll('[data-quote-open]').forEach((button) => button.addEventListener('click', () => openModal(button.dataset.model)));
  document.querySelectorAll('[data-quote-close]').forEach((button) => button.addEventListener('click', closeModal));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeModal(); });

  const drawer = document.querySelector('[data-compare-drawer]');
  const itemsEl = document.querySelector('[data-compare-items]');
  const countEl = document.querySelector('[data-compare-count]');
  const storageKey = 'jacuzzi-world-shortlist';
  let shortlist = [];
  try { shortlist = JSON.parse(localStorage.getItem(storageKey) || '[]').slice(0, 3); } catch (_) { shortlist = []; }

  const persist = () => {
    try { localStorage.setItem(storageKey, JSON.stringify(shortlist)); } catch (_) {}
  };
  const syncButtons = () => {
    document.querySelectorAll('[data-compare-add]').forEach((button) => {
      const added = shortlist.some((item) => item.title === button.dataset.title);
      button.classList.toggle('is-added', added);
      button.setAttribute('aria-pressed', String(added));
      button.textContent = added ? 'Added ✓' : 'Compare +';
    });
  };
  const renderShortlist = () => {
    if (countEl) countEl.textContent = String(shortlist.length);
    if (itemsEl) {
      itemsEl.innerHTML = '';
      shortlist.forEach((item) => {
        const chip = document.createElement('span');
        chip.className = 'jw-compare-chip';
        const link = document.createElement('a');
        link.href = item.url;
        link.textContent = item.title;
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.setAttribute('aria-label', `Remove ${item.title}`);
        remove.textContent = '×';
        remove.addEventListener('click', () => {
          shortlist = shortlist.filter((candidate) => candidate.title !== item.title);
          persist();
          renderShortlist();
        });
        chip.append(link, remove);
        itemsEl.append(chip);
      });
    }
    drawer?.classList.toggle('is-open', shortlist.length > 0);
    syncButtons();
  };

  document.querySelectorAll('[data-compare-add]').forEach((button) => button.addEventListener('click', () => {
    const title = button.dataset.title;
    const exists = shortlist.some((item) => item.title === title);
    if (exists) shortlist = shortlist.filter((item) => item.title !== title);
    else if (shortlist.length < 3) shortlist.push({ title, url: button.dataset.url });
    else {
      const original = button.textContent;
      button.textContent = 'Maximum 3';
      window.setTimeout(() => { button.textContent = original; }, 1200);
    }
    persist();
    renderShortlist();
  }));
  document.querySelector('[data-compare-clear]')?.addEventListener('click', () => { shortlist = []; persist(); renderShortlist(); });
  document.querySelector('[data-compare-request]')?.addEventListener('click', () => {
    const names = shortlist.map((item) => item.title).join(', ');
    openModal(names ? `Compare: ${names}` : 'Model comparison');
  });
  renderShortlist();
});
